<template>
  <section>
    <div class="box">
      <div class="columns is-multiline">
        <div class="column" v-for="novel in novelsFiltered" v-bind:key="novel.id">
          <router-link class="card" :to="{ name: 'novel', params: { novelId: novel.id } }">
            <div class="card-image" v-show="isImageCover">
              <figure class="image">
                <img :src="novel['image-cover']">
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-left">
                  <figure class="image is-48x48">
                    <img :src="novel['image-small']">
                  </figure>
                </div>
                <div class="media-content">
                  <p class="title is-4">{{ novel['name-en'] }}</p>
                  <p class="subtitle is-6">{{ novel['name-th'] }}</p>
                </div>
              </div>

              <div class="content" v-show="isDescription">
                {{ novel.description }}
              </div>
            </div>
            <header class="card-header" v-show="novel.hasOwnProperty('subscriptions') && donateTotal > 0">
              <a class="card-header-title">ระดับขั้นของท่าน</a>
              <p class="card-header-icon">{{ mySubscriptionName(novel) }}</p>
            </header>
            <footer class="card-footer" v-show="isSelectButton">
              <button class="button is-primary is-fullwidth is-radiusless" v-if="!novel.hasOwnProperty('subscriptions')" disabled>เรื่องนี้ยังไม่เปิดสนับสนุน</button>
              <button class="button is-primary is-fullwidth is-radiusless" v-else @click.prevent="$emit('select', novel)">
                <p v-if="donateTotal > 0">เลื่อนระดับขั้น</p>
                <p v-else>สมัครเข้าฝึกเซียน</p>
              </button>
              <!-- <button class="button is-primary is-fullwidth" @click="addSubscription(novel['.key'])">Add Subscription</button> -->
            </footer>
          </router-link>
        </div>
      </div>
    </div>
    <b-pagination
      :total="novels.length"
      :current.sync="pagination.current"
      :per-page="pagination.perPage">
    </b-pagination>
  </section>
</template>

<script>
import { db } from '@/firebase.config'
import { firebase } from '@firebase/app'

export default {
  model: {
    prop: 'novel',
    event: 'select'
  },
  props: {
    novel: Object,
    isImageCover: Boolean,
    isDescription: Boolean,
    isSelectButton: Boolean
  },
  metaInfo () {
    return {
      title: 'นิยายทั้งหมด',
      meta: [
        { property: 'og:title', content: 'นิยายทั้งหมด' },
        { property: 'og:description', content: 'นิยายน่าอ่าน นิยายแฟนตาซี นิยายกำลังภายใน นิยายแปลไทย' },
        { property: 'og:image', content: 'https://cdn-image.foodandwine.com/sites/default/files/styles/medium_2x/public/fiction-novels-food-and-love-header-ft-blog1017.jpg' },
        { property: 'og:url', content: this.$route.fullPath }
      ]
    }
  },
  data () {
    return {
      novels: [],
      pagination: {
        current: 1,
        perPage: 20
      }
    }
  },
  firestore () {
    return {
      novels: db.collection('novels')
    }
  },
  computed: {
    novelsFiltered () {
      if (this.$root.isImmortal) {
        return this.novels
      }
      return this.novels.filter(novel => novel.isHidden === false && this.donateTotal(novel.id) <= 0)
    }
  },
  methods: {
    donateTotal (novelId) {
      var completedPayments = this.$root.payments.filter(payment => payment.status === 'completed' && payment.novel_id === novelId)
      if (completedPayments.length > 0) {
        return completedPayments.map(payment => parseInt(payment.amount)).reduce((prev, next) => prev + next)
      }
      return 0
    },
    mySubscription (novel) {
      if (novel.subscriptions === undefined) { return }
      if (this.$root.isImmortal) {
        return novel.subscriptions.find(sub => sub.id === 'immortal')
      }
      return novel.subscriptions.find(sub => sub.price === this.donateTotal)
    },
    mySubscriptionName (novel) {
      var subscription = this.mySubscription(novel)
      if (subscription) {
        return subscription.name + ` (${subscription.price}${subscription.currency})`
      }
    },
    addSubscription (novel) {
      var novelRef = this.$firestore.novels.doc(novel)
      novelRef.update({
        subscriptions: firebase.firestore.FieldValue.arrayUnion({
          name: 'ขั้นเซียนอมตะ',
          id: 'immortal',
          color: 'is-light',
          isEnabled: false,
          price: 1000,
          currency: '฿',
          attributes: [
            'อ่านได้ทุกเรื่องทุกตอนในเว็บไซต์', 'คุ้มค่าที่สุด!', 'ได้รับการดูแลเป็นพิเศษ', 'เป็นการสนับสนุนตั้งแต่แรกเริ่ม'
          ]
        })
      })
    }
  }
}
</script>

<style lang="scss">
@include mobile {
  .tabs ul {
    flex-direction: column;

    li {
      width: 100%;
    }
  }
}
</style>
